export default "__VITE_ASSET__Ddm4f04v__"